import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Drag = (props) => (
  <Icon viewBox="0 0 6 22" {...props}>
    <g>
      <title>drag</title>
      <path d="M4 20h2v2H4v-2zm0-5h2v2H4v-2zm0-5h2v2H4v-2zm0-5h2v2H4V5zm0-5h2v2H4V0zM0 20h2v2H0v-2zm0-5h2v2H0v-2zm0-5h2v2H0v-2zm0-5h2v2H0V5zm0-5h2v2H0V0z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Drag;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Drag.js